export default __webpack_public_path__ + "static/media/blue_team_lost.5dc51cad.webp";